import React from 'react';
import { connect } from 'react-redux';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { getClient } from '../../ducks/clientProfileActions';

class NoteHead extends React.Component {
  componentDidMount() {
    let { clientId, history } = this.props;
    this.props.getClient(clientId, history);
  }

  render() {
    let { client } = this.props;
    let name = client ? `${client.first_name} ${client.last_name}` : '';
    return (
      <Breadcrumb>
        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
        <Breadcrumb.Item href={`/clients/${this.props.clientId}`}>
          {name}
        </Breadcrumb.Item>
        <Breadcrumb.Item active>{this.props.text}</Breadcrumb.Item>
      </Breadcrumb>
    );
  }
}

function mapStateToProps(state) {
  return {
    client: state.clientProfileReducer.client
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getClient: (clientId, history) => dispatch(getClient(clientId, history))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NoteHead);
